import type { MailboxInfo } from 'owa-client-types';
import isCopilotFeatureEnabled from './isCopilotFeatureEnabled';
import { isFeatureEnabled } from 'owa-feature-flags';
import getGlobalSettingsAccountMailboxInfo from 'owa-account-source-list-store/lib/selectors/getGlobalSettingsAccountMailboxInfo';
import hasM365CopilotLicense from './hasM365CopilotLicense';
import { isAIX00User } from 'owa-copilot-settings-store';
import { getApplicationSettings } from 'owa-application-settings';

/**
 * @param mailboxInfo Mailbox info
 * @returns true if the feature is enabled, false if the feature is disabled
 */
export default function isAttachmentSummarizationEnabled(
    mailboxInfo: MailboxInfo = getGlobalSettingsAccountMailboxInfo(),
    skipLanguageCheck?: boolean
): boolean {
    // for AIX00 users, we want to scope them specifically as they are special group of users
    // who help with early feedback.
    const devFlightEnabled =
        isFeatureEnabled('doc-attachment-summarization') ||
        (isAIX00User(mailboxInfo) &&
            getApplicationSettings('CopilotAIX00', mailboxInfo).attachmentSummaryEnabled);
    const hasLicense = hasM365CopilotLicense(mailboxInfo);
    const featureEnabled = !!isCopilotFeatureEnabled(
        'AttachmentSummarization',
        mailboxInfo,
        skipLanguageCheck
    );

    return devFlightEnabled && featureEnabled && hasLicense;
}
